<app-navbar-style-one></app-navbar-style-one>

<div class="section-title">
    <h2>Edit Sub Details of Post</h2>
</div>

<section class="contact-area">
    <div class="container">
        <div class="contact-inner-area">
            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="contact-form">
                        <form #otherForm="ngForm" >
                            <div class="row">
                                <div class="col-lg-12 col-md-6">
                                    <div class="form-group mb-3">
                                        <input required name="title" type="text" #title [ngModel]="details.title"
                                            class="form-control custom-border" id="title" placeholder="Title">
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-6">
                                    <div class="form-group mb-3">
                                        <input required  name="videoLink" type="text" #videoLink  [ngModel]="details.videoUrl"
                                            class="form-control custom-border" id="videoLink" placeholder="Video Link">
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group mb-3">
                                        <textarea required name="otherDescription" #otherDescription  [ngModel]="details.otherDescription"
                                            class="form-control" id="otherDescription" rows="6"
                                            placeholder="Description"></textarea>
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12">
                                    <button type="submit" class="default-btn"(click)="submitOtherDetails(title.value,videoLink.value,otherDescription.value)"><i class='bx bx-paper-plane'></i> Update
                                        DETAILS</button>
                                </div>
                            </div>
                        </form>

                        <br>
                        <hr>

                        <h4>Update Image</h4>
                        <div class="row">
                            <div class="col-lg-5 col-md-12">
                                <div class="products-details-image">
                                    <a href="{{details.imageUrl}}" class="popup-btn">
                                        <img src="{{details.imageUrl}}" alt="image">
                                    </a>
                                </div>
                            </div>
                            <div class="col-lg-7 col-md-12">
                                <div class="form-group mb-3">
                                    <input type="file" class="file-input" #fileUploadVehicleReg required
                                        accept=".jpg, .jpeg, .png" (change)="onFileSelectedVehicleReg($event)">
                                </div>
                                <button (click)="saveImageChanges()" class="default-btn"><i
                                        class='bx bx-paper-plane'></i> Update Image</button>

                                        <br><br>
                                        <button (click)="deleteImage()" class="default-btn" style="background-color: red;"><i
                                        class='bx bx-paper-plane'></i> Delete Image</button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<script async src="https://www.googletagmanager.com/gtag/js?id=G-C8F6CSWD62"></script>
<script>
    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('js', new Date());

    gtag('config', 'G-C8F6CSWD62');
</script>